import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Flex from "../../../../../DefaultStyles/Flex";
import { SearchTag } from "../ChatSearchResult";
import ToggleBtn from "../../../../../Button/ToggleBtn";
import { isNewChat } from "../../../../../../pages/Party/ChatInfo";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import SendChatModal from "./SendChatModal";
import { IMessageData } from "../RecentChat";

interface RecentChatHeaderProps {
  dropDownValue: {
    label?: string;
  };
  searchValue?: string;
  isFirebaseChat: boolean;
  toggleButtonEvent: () => void;
  roomId: number;
  messageData: IMessageData[];
  setMessageData: Dispatch<SetStateAction<IMessageData[]>>;
}

export default function RecentChatHeader({
  dropDownValue,
  searchValue,
  isFirebaseChat,
  toggleButtonEvent,
  roomId,
  messageData,
  setMessageData,
}: RecentChatHeaderProps) {
  const navigate = useNavigate();

  // uid 1 or 3 is system owner
  const ownerUid = searchValue?.split("@")[1];
  const isSystemOwner = ownerUid === "1" || ownerUid === "3";

  const [sendChatModal, setSendChatModal] = useState(false);

  return (
    <>
      <RecentChatHeaderContainer>
        <Flex>
          <>
            {dropDownValue?.label?.split("@")[0] &&
              searchValue?.split("@")[0] && (
                <SearchTag
                  onClick={() => {
                    if (dropDownValue?.label?.includes("PID")) {
                      navigate(`/party/info/${searchValue?.split("@")[0]}`);
                    } else {
                      navigate(`/users/info/${searchValue?.split("@")[0]}`);
                    }
                  }}
                  isClickable={true}
                >
                  {dropDownValue?.label?.split("@")[0]}_
                  {searchValue?.split("@")[0]}
                </SearchTag>
              )}
          </>

          <>
            {dropDownValue?.label?.split("@")[1] && ownerUid && (
              <SearchTag
                isClickable={true}
                onClick={() => {
                  if (dropDownValue?.label?.split("@")[1]) {
                    navigate(`/users/info/${ownerUid}`);
                  }
                }}
              >
                {dropDownValue?.label?.split("@")[1]}
                {" UID"}_{ownerUid}
              </SearchTag>
            )}
          </>

          <>
            {dropDownValue?.label?.split("@")[2] &&
              searchValue?.split("@")[2] && (
                <SearchTag
                  isClickable={true}
                  onClick={() => {
                    if (dropDownValue?.label?.split("@")[2]) {
                      navigate(`/users/info/${searchValue?.split("@")[2]}`);
                    }
                  }}
                >
                  {dropDownValue?.label?.split("@")[2]}
                  {" UID"}_{searchValue?.split("@")[2]}
                </SearchTag>
              )}
          </>

          {isNewChat ? (
            <Flex gapSize={8}>
              <ToggleBtn
                check={!isFirebaseChat}
                checkEvent={toggleButtonEvent}
              />

              <ChatType isFirebase={isFirebaseChat}>
                {isFirebaseChat ? "firebase" : "새 채팅"}
              </ChatType>
            </Flex>
          ) : (
            <></>
          )}
        </Flex>

        {isSystemOwner && (
          <ConfirmBtn
            btnText="채팅 보내기"
            btnColor="mint"
            btnClickEvent={() => setSendChatModal(true)}
          />
        )}
      </RecentChatHeaderContainer>

      {sendChatModal && (
        <SendChatModal
          closeEvent={() => setSendChatModal(false)}
          partyId={+searchValue?.split("@")[0]! ?? 0}
          roomId={roomId}
          targetUid={+searchValue?.split("@")[2]! ?? 0}
          ownerUid={+ownerUid!}
          chatList={messageData}
          setChatList={setMessageData}
        />
      )}
    </>
  );
}

const RecentChatHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @media screen and (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ChatType = styled.span<{ isFirebase: boolean }>`
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  color: ${({ isFirebase, theme }) =>
    !isFirebase ? theme.buttonColor.blueNormal : theme.buttonColor.lineHover};
`;
